import { render, staticRenderFns } from "./EditMedicaoForm.vue?vue&type=template&id=c202884c"
import script from "./EditMedicaoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMedicaoForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditMedicaoForm.vue?vue&type=style&index=0&id=c202884c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports